import { Account, OpenPosition } from '@monorepo/types';
import {
  ACCOUNT_QUERY_KEYS,
  ACCOUNT_STALE_TIME,
  DEFAULT_POSITIONS_LIMIT,
  DEFAULT_POSITIONS_PAGE,
} from '../constants';

/**
 * Creates a React Query configuration for fetching open positions data.
 *
 * @param positionStore - The position store instance with getOpenPositions method
 * @param account - The account to fetch open positions for
 * @param page - The page number for pagination (default: 1)
 * @param limit - The number of items per page (default: 100)
 * @param enabled - Whether the query should be enabled (default: true)
 * @returns React Query configuration object
 */
export const createOpenPositionsQuery = (
  positionStore: {
    getOpenPositions: (
      tsAccountId: string,
      options?: { page: number; limit: number },
    ) => Promise<{ results: OpenPosition[]; total: number }>;
  },
  account: Account | undefined,
  page = DEFAULT_POSITIONS_PAGE,
  limit = DEFAULT_POSITIONS_LIMIT,
  enabled = true,
) => ({
  queryKey: ACCOUNT_QUERY_KEYS.OPEN_POSITIONS(
    account?.tsAccountId || '',
    page,
    limit,
  ),
  queryFn: async () => {
    if (!account?.tsAccountId) throw new Error('Account ID is required');
    return positionStore.getOpenPositions(account.tsAccountId, {
      page,
      limit,
    });
  },
  staleTime: ACCOUNT_STALE_TIME,
  enabled: enabled && !!account?.tsAccountId,
});
